'use strict';
/**
 * Base local storage class that accepts a config and can generate middle or replay actions
 */

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var ReduxLocalStorageMiddleware = /*#__PURE__*/function () {
  /**
   * Create the local storage middleware
   * @param {Object} config - A config object
   * @property {String} config.storageKey - Where to store actions in local storage
   * @property {String} [config.actionIdentifier] - The property of the action to use as a unique ID. Defaults to type
   */
  function ReduxLocalStorageMiddleware() {
    var config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    (0, _classCallCheck2.default)(this, ReduxLocalStorageMiddleware);

    if (!config.storageKey) {
      throw new Error('A config object with a storageKey property is required');
    }

    this.storageKey = config.storageKey;
    this.actionIdentifier = config.actionIdentifier || 'type';
  }
  /**
   * Store multiple actions of the same key
   * @param {String} key
   * @param {Object} cache
   * @param {*} existingActions
   * @param {Object} newAction
   */


  (0, _createClass2.default)(ReduxLocalStorageMiddleware, [{
    key: "storeMultipleActions",
    value: function () {
      var _storeMultipleActions = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee(key, cache) {
        var existingActions,
            newAction,
            actionsToStore,
            _args = arguments;
        return _regenerator.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                existingActions = _args.length > 2 && _args[2] !== undefined ? _args[2] : [];
                newAction = _args.length > 3 ? _args[3] : undefined;

                if (Array.isArray(existingActions)) {
                  actionsToStore = newAction.persist(existingActions, newAction);
                } else {
                  // Turn single stored actions into an array for backward compatability
                  actionsToStore = newAction.persist([existingActions], newAction);
                }

                cache[key] = actionsToStore;
                return _context.abrupt("return", window.localStorage.setItem(this.storageKey, JSON.stringify(cache)));

              case 5:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function storeMultipleActions(_x, _x2) {
        return _storeMultipleActions.apply(this, arguments);
      }

      return storeMultipleActions;
    }()
    /**
     * Store an action
     * @param {String} key - The key that determines whether the action replaces an existing action
     * @param {Object} action - The redux action to be stored
     */
    // Disabling consistent return so we can return the promise for jest testing
    // eslint-disable-next-line consistent-return

  }, {
    key: "storeAction",
    value: function () {
      var _storeAction = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee2(key, action) {
        var cache;
        return _regenerator.default.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.prev = 0;
                cache = JSON.parse(window.localStorage.getItem(this.storageKey) || '{}');

                if (!(typeof action.persist === 'function')) {
                  _context2.next = 4;
                  break;
                }

                return _context2.abrupt("return", this.storeMultipleActions(key, cache, cache[key], action));

              case 4:
                cache[key] = action;
                return _context2.abrupt("return", window.localStorage.setItem(this.storageKey, JSON.stringify(cache)));

              case 8:
                _context2.prev = 8;
                _context2.t0 = _context2["catch"](0);

              case 10:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this, [[0, 8]]);
      }));

      function storeAction(_x3, _x4) {
        return _storeAction.apply(this, arguments);
      }

      return storeAction;
    }()
    /**
     * Generate the middleware to be used with Redux's applyMiddleware
     * @return {Middleware} Redux middleware
     */

  }, {
    key: "generateMiddleware",
    value: function generateMiddleware() {
      var _this = this;

      return function (store) {
        _this.store = store;
        return function (next) {
          return function (action) {
            if (action.persist) {
              _this.storeAction(action[_this.actionIdentifier], action);
            }

            return next(action);
          };
        };
      };
    }
    /**
     * Rehydrate the redux store with the previously stored action
     */

  }, {
    key: "replayActions",
    value: function replayActions() {
      var _this2 = this;

      try {
        var persistedActions = JSON.parse(window.localStorage.getItem(this.storageKey));
        Object.keys(persistedActions).forEach(function (actionKey) {
          if (Array.isArray(persistedActions[actionKey])) {
            // We stored an array of actions
            persistedActions[actionKey].forEach(function (action) {
              // Don't include persist on the replayed action...it messes with storage
              delete action.persist;

              _this2.store.dispatch(action);
            });
          } else {
            // We stored a single action
            // Don't include persist on the replayed action...it messes with storage
            delete persistedActions[actionKey].persist;

            _this2.store.dispatch(persistedActions[actionKey]);
          }
        });
      } catch (e) {// Local storage isn't available
      }
    }
  }]);
  return ReduxLocalStorageMiddleware;
}();

module.exports = ReduxLocalStorageMiddleware;